import { inject, Injectable, PLATFORM_ID } from "@angular/core";
import { isPlatformBrowser, isPlatformServer } from "@angular/common";

@Injectable({
  providedIn: 'root',
})
export class BrowserApiService {
  private platformId = inject(PLATFORM_ID)
  private _isBrowser = isPlatformBrowser(this.platformId);
  private _isServer = isPlatformServer(this.platformId);

  isBrowser(): boolean {
    return this._isBrowser;
  }

  isServer(): boolean {
    return this._isServer;
  }
}
